module.exports = __webpack_public_path__ + "img/1929-35-Charles Houston-cropped.bc987420.jpg";